import { render, staticRenderFns } from "./KbzMM.vue?vue&type=template&id=0f8fefc3&"
var script = {}
import style0 from "./KbzMM.vue?vue&type=style&index=0&id=0f8fefc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports